import { notification } from "antd";

export const notifiyUser = (response, successMessage, errorMessage) => {
  notification.destroy()
  if (response instanceof Error) {
    notification.error({
      message: errorMessage,
      placement: "bottomRight",
    });
  } else {
    notification.success({
      message: successMessage,
      placement: "bottomRight",
    });
  }
};
